import React from "react";
import "../tables.css";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import Button from "@mui/material/Button";
import AppDialog from "../appDialog";
import FormatText from "./prettyPrintDetailsText";

const ViewDetailsModal = ({
  cell,
  openDetail,
  currentColumnRef,
  handleDetailOpen,
  handleDetailClose,
  title,
}) => {
  const tooltip = "View Details";

  return (
    <>
      <IconButton
        color="primary"
        size="small"
        sx={{ ml: 0.5, "&:hover": { bgcolor: "action.hover" } }}
        onClick={() => handleDetailOpen({ cell })}
      >
        <Tooltip id="button-report" title={tooltip}>
          <MoreHorizIcon fontSize="small" />
        </Tooltip>
      </IconButton>

      <AppDialog
        open={openDetail}
        onClose={handleDetailClose}
        title={title}
        maxWidth="sm"
        actions={
          <Button variant="text" color="inherit" onClick={handleDetailClose}>
            Close
          </Button>
        }
      >
        <FormatText columnID={title} detailText={currentColumnRef.current} />
      </AppDialog>
    </>
  );
};

export default ViewDetailsModal;
